$(() => {
    if (document.getElementById('admin-partner-users') != null) {
        $('.js-email-update').click(function(){
            $('#email').submit();
        });
    }

    $('.js-send-invite-mail').on('click', function(e) {
        $('#admin-client-user-send-invite-mail_modal').modal('show');
    });
    $('.admin-user-send-invite-mail-exec').on('click', function(e) {
        $('#send_invite_mail').submit();
    });
    $('.js-send-entry-mail').on('click', function(e) {
        $('#admin-client-user-send-entry-mail_modal').modal('show');
    });
    $('.admin-user-send-entry-mail-exec').on('click', function(e) {
        $('#send_entry_mail').submit();
    });
    $('.js-client-cancellation').on('click', function(e) {
        $('#admin-client-cancellation_modal').modal('show');
    });
    $('.admin-user-cancellation-exec').on('click', function(e) {
        $('#cancellation').submit();
    });
    $('.js-partner-cancellation').on('click', function(e) {
        $('#admin-partner-cancellation_modal').modal('show');
    });
    $('.admin-patner-cancellation-exec').on('click', function(e) {
        $('#cancellation').submit();
    });
});

